import * as React from 'react';
import {
    FilterLiveSearch, FunctionField,
    NumberField, TextField,
    useLocale,
    // TextInput,
    useTranslate,
} from 'react-admin';

// import {EditableDatagrid, RowForm} from "@react-admin/ra-editable-datagrid";
// import {RowForm} from "@react-admin/ra-editable-datagrid";
import ListComponentAdmin from "../../_common/ListComponentAdmin";
import TableActions from "../../_common/TableActions";
import useMyStyles from "../../utils/useMyStyles";
// import {universalTopFilters} from "../universalView/universalTopFilters";
// import {CardContent, useMediaQuery} from "@material-ui/core";
import {CardContent, useMediaQuery} from "@material-ui/core";
import CardComp from "../../_common/Asside/CardComp";
import {
    BooleanFieldCompAct,
    DateFieldComp,
    FilterDataAside, TextFieldBold,
    //NumberInputFloatComp,
    //UserInfo,
} from "../../_common/CompReact";
// import {validateFirstName, validateReq} from "../utils/components/validateTable";
// import {Box} from "@mui/material";
import TrueFalseFilters from "../../_common/TrueFalseFilters";
import DatagridComponentAdmin from "../../_common/DatagridComponentAdmin";
import {useSelectedColumns} from "@react-admin/ra-preferences";
import CroppedLongField from "../../_common/CroppedLongField";
import MySimpleList from "../../_common/MySimpleList";
import {EditTextFieldComp} from "../../_common/EditTextFieldComp";
import SelectAndSaveChoices from "../../_common/SelectAndSaveChoices";
import {choicesDisplayOption} from "../../_constants/choices";
import {Box} from "@mui/material";
import config from "../../utils/config";

const universalTopFilters = (resource, locale) => {
    let dt = [];
    return dt;
}

const UniversalAside = (props) => {
    //const {locale} = props;
    return (
        <CardComp id="aside_card">
            <CardContent>
                <FilterLiveSearch/>
                {/*<TrueFalseFilters field={'show_in_product_card'} label={'Show in product card'}/>*/}
                <TrueFalseFilters field={'is_hide_in_filters_list'} label={'Hide in filters list'}/>
                <TrueFalseFilters field={'is_hide_on_product_page'} label={'Hide on product page'}/>
                <TrueFalseFilters field={'many_values'} label={'Many values'}/>
                <TrueFalseFilters field={'required'} label={'Required'}/>
                <TrueFalseFilters field={'is_pricing'} label={'Is pricing'}/>
                <FilterDataAside fields={'updated'} name={'update'}/>
            </CardContent>
        </CardComp>
    )
};

/*export const tableFilters = [
    <TextInput label="Search" source="q" alwaysOn/>,
    /!*<BooleanInput label="Only viewed" source="viewed" alwaysOff/>,*!/
];*/


const ColumnsForList = (resource, locale, classes, isSmall) => {
    const translate = useTranslate();
    let columns = {
        id: <NumberField source="id" headerClassName={classes.headerShortWidth}/>,
        is_active:
            <SelectAndSaveChoices
                label={'A'}
                source="is_active"
                statuses={[
                    {id: true, name: 'Active'},
                    {id: false, name: 'No active'},
                ]}
                resource={resource}
                textAlign={'center'}
                showTextValue={true}
                width={'2em'}
                edit={true}
                color={'green'}
                circle={'no inv'}
            />,
        // prompt: <TextFieldBold source={`prompt`} label={translate('Prompt')} cellClassName={classes.prompt_name}/>,
        name: <TextFieldBold source={`name[${locale}]`} label={translate('Name')}/>,

        sort_product_page:
        /*<NumberField source="sort_product_page" label={'Order in product page'}/>,*/
            <EditTextFieldComp resource={resource} source={'sort_product_page'}
                               label={'Order in product page'} type={'number'}/>,
        sort_filter_listing_page:
        /*<NumberField source="sort_filter_listing_page" label={'Order in listing'}/>,*/
            <EditTextFieldComp resource={resource} source={'sort_filter_listing_page'}
                               label={'Order in listing'} type={'number'}/>,

        required: <BooleanFieldCompAct source="required"
                                       label={translate("Required")} textAlign={"center"}/>,
        is_hide_in_filters_list: <BooleanFieldCompAct source="is_hide_in_filters_list"
                                                      label={translate("Hide in filters list")} textAlign={"center"}/>,
        is_hide_on_product_page: <BooleanFieldCompAct source="is_hide_on_product_page"
                                                      label={translate("Hide on product page")} textAlign={"center"}/>,
        is_pricing: <BooleanFieldCompAct source="is_pricing"
                                         label={translate("Is pricing")} textAlign={"center"}/>,
        many_values: <BooleanFieldCompAct source="many_values"
                                          label={translate("Many values")} textAlign={"center"}/>,
        display_option:
            <SelectAndSaveChoices
                label={translate('Display Option')}
                source="display_option"
                statuses={choicesDisplayOption}
                resource={resource}
                textAlign={'center'}
                showTextValue={true}
                //edit={true}
                width={'10em'}
            />,
        /*required: <BooleanFieldComp source="required"
                                    label={translate("Required")} textAlign={"center"}/>,*/

        /*default_value: <TextField source={`default_value`} label={translate('Default Value')}/>,*/
        url: <TextField source={`url`} label={translate('Url')}/>,

        description_file:
            <FunctionField
                label={translate('Description file')}
                cellClassName={classes.cellPdfFile}
                render={(record) => (
                    <Box>
                        {record.description_file
                            ?
                            <a href={`${config.apiUrl}files_media/${record.description_file}`}
                               target={"_blank"}>
                                {`${record.description_file}`}
                            </a>
                            : '-'
                        }
                    </Box>
                )}
            />,
        source: <CroppedLongField source="source" long={10} label={translate('Source')}/>,
        updated: <DateFieldComp source="updated" label={translate('Update')} textAlign={'center'}
                                locale={'us'} cellClassName={classes.date_st}/>,
    }
    if (isSmall) {
        delete columns.id
        delete columns.source
        delete columns.updated
    }
    return columns;
};

export const FeatureTypeList = props => {
    const classes = useMyStyles();
    const {resource} = props;

    // console.log('resource=============>', resource)
    // const {id} = record || {};
    const locale = useLocale();
    const isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('xs');
    });

    const postRowStyle = (record, index) => ({
        backgroundColor: record?.is_paid && '#efe',
        // display: "table-cell",
    });
    const columns = useSelectedColumns({
        preferences: `${resource}list.columns`,
        columns: ColumnsForList(resource, locale, classes, isSmall),
        omit: ["description_file"],
    });

    return (
        <ListComponentAdmin
            {...props}
            //hasCreate={true}
            title={''}
            actions={<TableActions
                preference={`${resource}${"list.columns"}`}
                columns={ColumnsForList(resource, locale, classes, isSmall)}
                //select={false}
                create={true}
                filter={true}
            />}
            is_bulkActionButtons={true}
            filters={universalTopFilters(resource, locale)}
            sort={{field: 'id', order: 'DESC'}}
            aside={<UniversalAside locale={locale}/>}
        >
            {isSmall
                ?
                <MySimpleList
                    columns={columns}
                    postRowStyle={postRowStyle}
                />
                :
                /*<DatagridComponentAdmin {...props} rowClick="edit" expand={<PostShow/>}>*/
                <DatagridComponentAdmin {...props} rowClick="edit" rowStyle={postRowStyle}>
                    {columns}
                </DatagridComponentAdmin>
            }
        </ListComponentAdmin>
    )
};